import dayjs from 'dayjs';
import { ProductType } from '@/shared/enums';
import { getActiveScheduleByType } from '@/shared/utils';

const ProductStatus = {
  FUTURE: 'FUTURE',
  UNCATCHUPABLE: 'UNCATCHUPABLE',
  PLAYABLE: 'PLAYABLE',
};

export default {
  data() {
    return {
      info: this.$services.resolve('info'),
      time: this.$services.resolve('time'),
    };
  },
  computed: {
    status() {
      if (this.product.type === ProductType.PROGRAMME) {
        const future = this.product.since && dayjs(this.product.since).valueOf() > this.time.now.valueOf();
        const completed = this.product.till && dayjs(this.product.till).valueOf() < this.time.now.valueOf();
        const catchupAvailable = this.info.freeCatchupAvailable && this.product.catchupTill && dayjs(this.product.catchupTill).valueOf() > this.time.now.valueOf();

        if (future) {
          return ProductStatus.FUTURE;
        }

        if (completed && !catchupAvailable) {
          return ProductStatus.UNCATCHUPABLE;
        }
      } else if (getActiveScheduleByType(this.product, 'SOON')) {
        return ProductStatus.FUTURE;
      }

      return ProductStatus.PLAYABLE;
    },
    isFuture() {
      return this.status === ProductStatus.FUTURE;
    },
    isUncatchupable() {
      return this.status === ProductStatus.UNCATCHUPABLE;
    },
    isPlayable() {
      return this.status === ProductStatus.PLAYABLE;
    },
    isFavouritable() {
      return [ProductType.LIVE, ProductType.SERIAL, ProductType.VOD].includes(this.product.type);
    },
    isProgrammeDisabled() {
      const { currentLiveProgram } = this.state ?? {};
      const hasLiveProgram = currentLiveProgram && !currentLiveProgram.empty;
      const isCatchup = this.product?.type === ProductType.CATCH_UP;

      if (hasLiveProgram && !isCatchup) {
        return currentLiveProgram.isPlaybackDisabled;
      }

      const product = this.product?.currentProgram ?? this.product;

      if (![ProductType.PROGRAMME, ProductType.LIVE, ProductType.CATCH_UP].includes(product?.type)) {
        return false;
      }

      return product?.isPlaybackDisabled;
    },
  },
};
